export enum SquareFilterType {
  ITEM = "ITEM",
  ITEM_OPTION = "ITEM_OPTION",
  CATEGORY = "CATEGORY",
  IMAGE = "IMAGE",
  ITEM_VARIATION = "ITEM_VARIATION",
}
